// extracted by mini-css-extract-plugin
export default {"back-to-top":"style_back-to-top__cyTrQ","scroll":"style_scroll__4VuEr"};